<powerbi-report
    [embedConfig]="reportConfig"
    cssClassName="report-container"
    [eventHandlers]="eventHandlersMap"
>
</powerbi-report>